import { Grid, Paper, styled } from '@mui/material';

export const StyledLayoutWrap = styled(Paper)(() => ({
	width: '100%',
	maxWidth: '450px',
	padding: '16px',
	borderRadius: '12px',
}));

export const StyledHeaderWrap = styled(Grid)(() => ({
	flexDirection: 'column',
	gap: '8px',
}));
